import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ seconds, resetKey, running = true }) => {
    const [remaining, setRemaining] = useState(seconds);

    useEffect(() => {
        if (!seconds) return;
        setRemaining(seconds);
    }, [seconds, resetKey]);

    useEffect(() => {
        if (!seconds || !running) return;
        const iv = setInterval(() => {
            setRemaining(r => (r <= 1 ? 0 : r - 1));
        }, 1000);
        return () => clearInterval(iv);
    }, [seconds, resetKey, running]);

    if (!seconds) return null;
    return (
        <div style={{
            fontWeight: 700, fontSize: '1.05rem', marginBottom: '10px',
            color: !running ? '#9ca3af' : remaining <= 5 ? '#dc2626' : '#374151'
        }}>
            ⏱ {remaining}s{!running ? ' (stopped)' : ''}
        </div>
    );
};

export default CountdownTimer;